// BudgetDragLayer Component
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { DragLayer } from 'react-dnd'

import PlannerTaskItem from '../../task/task_item/task_item.jsx'
import PhaseItem from '../../project/budget/phase_item/phase_item.jsx'
import ActivityItem from '../../project/budget/activity_item/activity_item.jsx'

function getItemStyles (props) {
  const { initialOffset, currentOffset } = props
  if (!initialOffset || !currentOffset) {
    return {
      display: 'none'
    }
  }

  const { x: oX } = initialOffset
  const { x, y } = currentOffset
  const transform = `translate(${198 - (oX - x)}px, ${y - 29}px)`

  return {
    transform: transform,
    WebkitTransform: transform
  }
}

@DragLayer((monitor) => ({
  item: monitor.getItem(),
  itemType: monitor.getItemType(),
  initialOffset: monitor.getInitialSourceClientOffset(),
  currentOffset: monitor.getClientOffset(),
  isDragging: monitor.isDragging()
}))
class ItemDragLayer extends Component {
  static propTypes = {
    initialOffset: PropTypes.shape({
      x: PropTypes.number.isRequired,
      y: PropTypes.number.isRequired
    }),
    currentOffset: PropTypes.shape({
      x: PropTypes.number.isRequired,
      y: PropTypes.number.isRequired
    }),
    className: PropTypes.string,
    isDragging: PropTypes.bool.isRequired,
    item: PropTypes.object
  };

  render () {
    const { isDragging, item, className } = this.props

    return (
      <div
        className={`cdraglayer${isDragging ? ' active' : ''}${
          className ? ' ' + className : ''
        }`}
        style={getItemStyles(this.props)}
      >
        {item && this._renderItem(item)}
      </div>
    )
  }

  _renderItem (item) {
    const { dragItemType, id, ...others } = item
    if (dragItemType === 'task') {
      return <PlannerTaskItem key={id} task={item} {...others} />
    } else if (dragItemType === 'phase') {
      return <PhaseItem key={id} phase={item} showItems={false} {...others} />
    } else if (dragItemType === 'activity') {
      return <ActivityItem key={id} activity={item} {...others} />
    }

    return null
  }
}

export default ItemDragLayer
